var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "hireModal",
            "data-focus": "false",
            "data-keyboard": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-scrollable" },
            [
              _c("ValidationObserver", {
                ref: "letter",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c("div", { staticClass: "letter-modal" }, [
                          _c("div", { staticClass: "note-wrap" }, [
                            _c("div", { staticClass: "letter-title" }, [
                              _vm._v("錄取通知"),
                            ]),
                            _c("div", { staticClass: "note-title" }, [
                              _vm._v("可動態套入信件內容，請參考以下參數"),
                            ]),
                            _c("div", { staticClass: "note-table mb-4" }, [
                              _vm.acceptanceParameters
                                ? _c(
                                    "table",
                                    _vm._l(
                                      _vm.acceptanceParameters,
                                      function (parameter) {
                                        return _c(
                                          "tr",
                                          { key: parameter.MailParameterCode },
                                          [
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  parameter.MailParameterName
                                                )
                                              ),
                                            ]),
                                            _c("td", [
                                              _c("span", [_vm._v(" {{")]),
                                              _vm._v(
                                                _vm._s(
                                                  parameter.MailParameterCode
                                                )
                                              ),
                                              _c("span", [_vm._v("}} ")]),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                          _c(
                            "form",
                            {
                              on: {
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "modal-content border-0" },
                                [
                                  _c("div", { staticClass: "modal-body" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("姓名："),
                                      ]),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.acceptanceMail.Name)),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "w-100",
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v("錄取單位："),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("treeselect", {
                                                      attrs: {
                                                        options:
                                                          _vm.departmentOptions,
                                                        searchable: true,
                                                        "show-count": true,
                                                        "default-expand-level": 1,
                                                        placeholder: "請選擇",
                                                        valueFormat: "object",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "option-label",
                                                            fn: function ({
                                                              node,
                                                              shouldShowCount,
                                                              count,
                                                              labelClassName,
                                                              countClassName,
                                                            }) {
                                                              return _c(
                                                                "label",
                                                                {
                                                                  class:
                                                                    labelClassName,
                                                                  attrs: {
                                                                    for: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        node.label
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  shouldShowCount
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          class:
                                                                            countClassName,
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " (" +
                                                                              _vm._s(
                                                                                count
                                                                              ) +
                                                                              ") "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.acceptanceMail
                                                            .Department,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.acceptanceMail,
                                                            "Department",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "acceptanceMail.Department",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _vm._v(" 工作職稱： "),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          filterable: "",
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.acceptanceMail
                                                              .Job,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.acceptanceMail,
                                                              "Job",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "acceptanceMail.Job",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.positionOptions,
                                                        function (position) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: position.Code,
                                                              attrs: {
                                                                label:
                                                                  position.Name,
                                                                value:
                                                                  position.Name,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v("聯絡資訊："),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          filterable: "",
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.acceptanceMail
                                                              .ContactInfo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.acceptanceMail,
                                                              "ContactInfo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "acceptanceMail.ContactInfo",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.contactOptions,
                                                        function (person) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: person.Guid,
                                                              attrs: {
                                                                label:
                                                                  person.Name,
                                                                value:
                                                                  person.Name,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("附件："),
                                        ]),
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: "",
                                              "auto-upload": false,
                                              "show-file-list": false,
                                              "on-change": _vm.uploadFile,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary",
                                                },
                                              },
                                              [_vm._v("點擊上傳")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.uploadFileList
                                          ? _vm._l(
                                              _vm.uploadFileList,
                                              function (file) {
                                                return _c(
                                                  "div",
                                                  { key: file.FileGuid },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          "margin-top": "20px",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.$common.downloadFile(
                                                              {
                                                                fileGuid:
                                                                  file.FileGuid,
                                                                fileType:
                                                                  file.FileContentType,
                                                              }
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("eva-icon", {
                                                          attrs: {
                                                            fill: "#000",
                                                            name: "attach-outline",
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "margin-left":
                                                                "15px",
                                                              "vertical-align":
                                                                "text-top",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  file.FileName
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              display:
                                                                "inline-block",
                                                              position:
                                                                "absolute",
                                                              right: "25px",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.removeFile(
                                                                  {
                                                                    fileGuid:
                                                                      file.FileGuid,
                                                                    fileGroupGuid:
                                                                      file.FileGroupGuid,
                                                                  }
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("eva-icon", {
                                                              attrs: {
                                                                fill: "#000",
                                                                name: "trash-2-outline",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("錄取信件範本："),
                                        ]),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "請選擇",
                                            },
                                            model: {
                                              value: _vm.acceptanceTemplateGuid,
                                              callback: function ($$v) {
                                                _vm.acceptanceTemplateGuid = $$v
                                              },
                                              expression:
                                                "acceptanceTemplateGuid",
                                            },
                                          },
                                          _vm._l(
                                            _vm.acceptanceTemplates,
                                            function (template) {
                                              return _c("el-option", {
                                                key: template.MailTemplateGuid,
                                                attrs: {
                                                  label:
                                                    template.MailTemplateName,
                                                  value:
                                                    template.MailTemplateGuid,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "w-100",
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "mark",
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _vm._v(
                                                          "錄取信件主旨： "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("el-input", {
                                                      attrs: {
                                                        clearable: "",
                                                        placeholder:
                                                          "請輸入信件主旨或選擇範本",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.acceptanceMail
                                                            .MailSubject,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.acceptanceMail,
                                                            "MailSubject",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "acceptanceMail.MailSubject",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "w-100",
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "mark",
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _vm._v(
                                                          "錄取信件內容： "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("VueEditor", {
                                                      staticStyle: {
                                                        background:
                                                          "rgb(255, 255, 255)",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.acceptanceMail
                                                            .MailTemplateBody,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.acceptanceMail,
                                                            "MailTemplateBody",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "acceptanceMail.MailTemplateBody",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.personData.ResumeType == "DL"
                                      ? _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("ValidationProvider", {
                                              staticClass: "w-100",
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: { for: "" },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mark",
                                                              },
                                                              [_vm._v("*")]
                                                            ),
                                                            _vm._v(
                                                              "是否夾帶offer："
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                            attrs: {
                                                              placeholder:
                                                                "請選擇",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .acceptanceMail
                                                                  .IsSendOffer,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.acceptanceMail,
                                                                    "IsSendOffer",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "acceptanceMail.IsSendOffer",
                                                            },
                                                          },
                                                          [
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "是",
                                                                value: true,
                                                              },
                                                            }),
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "否",
                                                                value: false,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                            staticStyle: {
                                                              "font-size":
                                                                "13px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c("div", { staticClass: "modal-footer" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary",
                                        attrs: { type: "reset" },
                                        on: { click: _vm.closeHireMailModal },
                                      },
                                      [_vm._v(" 取消 ")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return handleSubmit(_vm.preview)
                                          },
                                        },
                                      },
                                      [_vm._v(" 預覽 ")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-success",
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.clickDisabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return handleSubmit(_vm.sendLetter)
                                          },
                                        },
                                      },
                                      [_vm._v(" 寄出 ")]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c("PreviewMailModal", {
        attrs: { type: "hire", mail: _vm.previewData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }